export default __webpack_public_path__ + "static/media/Earn.47b342ec.svg";